/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliverFeeGradeAmountRespVo } from './GetDeliverFeeGradeAmountRespVo';
import {
    GetDeliverFeeGradeAmountRespVoFromJSON,
    GetDeliverFeeGradeAmountRespVoFromJSONTyped,
    GetDeliverFeeGradeAmountRespVoToJSON,
    GetDeliverFeeGradeAmountRespVoToJSONTyped,
} from './GetDeliverFeeGradeAmountRespVo';

/**
 * 
 * @export
 * @interface GetDeliverFeeInternationRespVo
 */
export interface GetDeliverFeeInternationRespVo {
    /**
     * 仓库id
     * @type {number}
     * @memberof GetDeliverFeeInternationRespVo
     */
    warehouseId?: number;
    /**
     * 运输方式
     * @type {number}
     * @memberof GetDeliverFeeInternationRespVo
     */
    transportMethodId?: number;
    /**
     * 国际运费分组：1电商快递，2海运物流，3橙火服务，4韩国3PL
     * @type {number}
     * @memberof GetDeliverFeeInternationRespVo
     */
    orderTypeGroup?: number;
    /**
     * 运输方式的计费标准
     * 运输方式的计费标准编号
     * @type {number}
     * @memberof GetDeliverFeeInternationRespVo
     */
    chargeStandard?: number;
    /**
     * 起重起始值
     * @type {number}
     * @memberof GetDeliverFeeInternationRespVo
     */
    startValue?: number;
    /**
     * 起重最终值
     * @type {number}
     * @memberof GetDeliverFeeInternationRespVo
     */
    endValue?: number;
    /**
     * 步长
     * @type {number}
     * @memberof GetDeliverFeeInternationRespVo
     */
    stepSize?: number;
    /**
     * 等级金额
     * @type {Array<GetDeliverFeeGradeAmountRespVo>}
     * @memberof GetDeliverFeeInternationRespVo
     */
    gradeAmounts?: Array<GetDeliverFeeGradeAmountRespVo>;
}

/**
 * Check if a given object implements the GetDeliverFeeInternationRespVo interface.
 */
export function instanceOfGetDeliverFeeInternationRespVo(value: object): value is GetDeliverFeeInternationRespVo {
    return true;
}

export function GetDeliverFeeInternationRespVoFromJSON(json: any): GetDeliverFeeInternationRespVo {
    return GetDeliverFeeInternationRespVoFromJSONTyped(json, false);
}

export function GetDeliverFeeInternationRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliverFeeInternationRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'transportMethodId': json['transportMethodId'] == null ? undefined : json['transportMethodId'],
        'orderTypeGroup': json['orderTypeGroup'] == null ? undefined : json['orderTypeGroup'],
        'chargeStandard': json['chargeStandard'] == null ? undefined : json['chargeStandard'],
        'startValue': json['startValue'] == null ? undefined : json['startValue'],
        'endValue': json['endValue'] == null ? undefined : json['endValue'],
        'stepSize': json['stepSize'] == null ? undefined : json['stepSize'],
        'gradeAmounts': json['gradeAmounts'] == null ? undefined : ((json['gradeAmounts'] as Array<any>).map(GetDeliverFeeGradeAmountRespVoFromJSON)),
    };
}

export function GetDeliverFeeInternationRespVoToJSON(json: any): GetDeliverFeeInternationRespVo {
    return GetDeliverFeeInternationRespVoToJSONTyped(json, false);
}

export function GetDeliverFeeInternationRespVoToJSONTyped(value?: GetDeliverFeeInternationRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseId': value['warehouseId'],
        'transportMethodId': value['transportMethodId'],
        'orderTypeGroup': value['orderTypeGroup'],
        'chargeStandard': value['chargeStandard'],
        'startValue': value['startValue'],
        'endValue': value['endValue'],
        'stepSize': value['stepSize'],
        'gradeAmounts': value['gradeAmounts'] == null ? undefined : ((value['gradeAmounts'] as Array<any>).map(GetDeliverFeeGradeAmountRespVoToJSON)),
    };
}

